import React, { useState, createContext, useContext } from "react";
import axios from "axios"
import { useEffect } from "react"
import { UserContext } from "./UserContext";

export const OrderContext = createContext();

export const OrderProvider = (props) => {
  const [user] = useContext(UserContext);
  const tokenOrder = user ? user.token : null;
  const [userOrder, setUserOrder] = useState([]);
  const [loading, setLoading] = useState(false);
    
  useEffect( () => {
    const order = async () => {
      setLoading(true)
      const result = await axios.get("https://backend-sportyan.vercel.app/api/order", {headers: {"Authorization" : "Bearer "+ tokenOrder}})
        .then((res) => {
          return res.data
        })
        .catch((err) =>{
          return err
        })
      setUserOrder(result)
      setLoading(false)
    }
    order()
  }, [tokenOrder])

  return (
    <OrderContext.Provider value={[userOrder, setUserOrder, loading, setLoading]}>
      {props.children}
    </OrderContext.Provider>
  );
};
